<template>
    <div class="mt-3" v-if="atendimento && atendimento.marcacao && atendimento.marcacao.estoque_solicitacoes && atendimento.marcacao.estoque_solicitacoes.length">
        <div class="small">
            <span class="badge badge-secondary mr-2">{{ atendimento.marcacao.estoque_solicitacoes.length }}</span>
            <a href="#" @click.prevent="exibir_solics = !exibir_solics" class="card-link">{{ $route.meta.vacina ? 'Solicitação de Consumo da Vacina' : 'Solicitações de Mat/Med' }}</a>
        </div>

        <div class="form-row" v-if="exibir_solics">
            <div class="col col-12 col-md-6">
                <ul class="list-group" v-if="exibir_solics">
                    <li class="list-group-item d-flex justify-content-between" v-for="(solic, isx) in atendimento.marcacao.estoque_solicitacoes" :key="isx">
                        <div>
                            <div>
                                #{{ solic.id_estoque_solicitacao }}
                                <span class="small text-muted ml-2" v-if="solic.local">{{ solic.local.st_estoque_local }}</span>

                                <span class="badge badge-danger ml-2" v-if="solic.fl_estorno">
                                    <i class="fas fa-undo-alt mr-1"></i>
                                    Devolução
                                </span>
                            </div>
                            <div v-for="(esi, iex) in solic.items" :key="iex">
                                <i class="fa-solid fa-circle-exclamation text-warning fa-fw mr-2" v-if="esi.links && esi.links.length && !esi.links.find(link => link.movimentacao.in_quantidade)"></i>
                                <i class="fa-solid fa-circle text-secondary fa-fw mr-2" v-else-if="!esi.links || !esi.links.length"></i>
                                <i class="fa-solid fa-circle-check text-success fa-fw mr-2" v-else></i>

                                <span v-if="id_estoque_item_selec && ( esi.item.id_estoque_item == id_estoque_item_selec)" class="badge badge-primary">
                                    {{ esi.item.search }}    
                                </span>
                                <span v-else>
                                    {{ esi.item.search }}
                                </span>

                                <ul v-if="esi.links && esi.links.length">
                                    <li v-for="(link, ilx) in esi.links" :key="ilx" class="small">
                                        {{ link.movimentacao.in_quantidade}}/{{ esi.in_quantidade }}
                                        <span v-if="link.movimentacao.st_lote" class="ml-3">
                                            Lote: {{ link.movimentacao.st_lote }}
                                        </span>
                                        <span>
                                            <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                            {{ $util.getFormatDate(link.movimentacao.dt_movimentacao) }}
                                            {{ link.movimentacao.dt_movimentacao.slice(11,16) }}
                                        </span>
                                        <span v-if="link.movimentacao.st_observacao" class="text-muted">
                                            <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                            {{ link.movimentacao.st_observacao }}
                                        </span>
                                    </li>
                                </ul>

                            </div>
                            
                        </div>
                        <div v-if="$route.meta.vacina && atendimento.dt_inicio && atendimento.dt_inicio.slice(0,10) == $util.hoje()">
                            <button type="button" class="btn btn-sm btn-outline-danger ml-1" v-if="solic.atendido && solic.items.find(item => item.links.find(link => link.movimentacao.in_quantidade))" @click="cancelar_atendimento_solicitacao_estoque(solic)">
                                Cancelar Atendimento
                            </button>

                            <button type="button" class="btn btn-primary" v-else-if="!solic.atendido" @click="atender_solicitacao_estoque(solic)">
                                Atender
                            </button>

                            <button type="button" class="btn btn-success" v-else-if="!isx" @click="regerar_solic_vacina()">
                                Re-Solicitar
                            </button>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="col col-12 col-md-6">
                <table class="table table-sm table-hover">
                    <thead>
                        <tr>
                            <th>Descrição</th>
                            <th class="text-right">Qtde</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item_estoque, iix) in lista_matmed_consolidada(atendimento)" :key="iix" :class="id_estoque_item_selec == item_estoque.id_estoque_item ? 'table-primary' : ''">
                            <td>
                                <a href="#" @click.prevent="id_estoque_item_selec = ( id_estoque_item_selec == item_estoque.id_estoque_item ? null : item_estoque.id_estoque_item )" class="card-link">
                                    {{ item_estoque.st_estoque_item }}
                                </a>
                            </td>
                            <td class="text-right">{{ item_estoque.qtde }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
        
        <pre v-if="false">{{ atendimento.marcacao.estoque_solicitacoes }}</pre>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    data() {   
        return { 
            exibir_solics: false, 
        }
    },

    props: ['atendimento'],

    methods: { 
        lista_matmed_consolidada (atendimento) { 
            if ( !atendimento || !atendimento.marcacao || !atendimento.marcacao.estoque_solicitacoes ) { 
                return [];
            }

            let lista = atendimento.marcacao.estoque_solicitacoes.flatMap(solic => { 
                return solic.items.map(function (item) { 
                    return { 
                        id_estoque_item: item.id_estoque_item, 
                        st_estoque_item: item.item.st_estoque_item, 
                        qtde: item.links.reduce((acc, link) => acc + ( link.movimentacao.in_quantidade * link.movimentacao.in_fator_saldo * -1 ), 0), 
                    };
                });     
            });

            lista = _.orderBy(
                _.map(
                    _.groupBy(lista, 'id_estoque_item'), 
                    (itens) => { 
                        return { 
                            ...itens[0], 
                            qtde: _.sumBy(itens, 'qtde'),
                        };
                    }
                ),
                'st_estoque_item'
            );

            return lista;
        },
    }
}
</script>
